import { useState } from "react";
import Button from "./Button";
import { Images } from "../assets";
import { useTranslation } from "react-i18next";

const ContactForm = () => {
  const { t } = useTranslation();

  // State for form inputs
  const [formData, setFormData] = useState({
    name: "",
    entreprise: "",
    email: "",
    phonenumber: "",
    message: "",
  });

  // Handle input changes and update state
  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.id]: event.target.value, // Update the field dynamically
    });
  };

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault(); // Prevents page reload

    fetch("/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }).then(async (response) => {
      if (response.status !== 204) {
        const data = await response.json();
        console.error(data);
        return;
      }
      setFormData({
        name: "",
        email: "",
        phonenumber: "",
        entreprise: "",
        message: "",
      });
    });
  };

  return (
    <section className="flex flex-col lg:flex-row gap-5 w-full px-5">
      {/* Contact Information Section */}
      <div className="w-full lg:w-1/3 flex flex-col items-center justify-center text-start bg-orange rounded-xl p-8 order-2 lg:order-1">
        <div className="w-full lg:w-4/5 flex flex-col items-start gap-7 md:gap-10">
          <h3 className="text-lg md:text-xl lg:text-2xl font-bold uppercase">
            {t("contactform.title")}
          </h3>

          <div className="flex gap-7 items-center">
            <img
              src={Images.LOCATION}
              alt={t("contactform.locationAlt")}
              className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12"
            />
            <a
              href="https://www.google.com/maps?q=Route+du+Village+1,+1409+Chanéaz,+Suisse"
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col items-start hover:underline active:underline italic font-extralight"
            >
              <p>{t("contactform.address.line1")}</p>
              <p>{t("contactform.address.line2")}</p>
            </a>
          </div>

          <div className="flex gap-7 items-center">
            <img
              src={Images.PHONE}
              alt={t("contactform.phoneAlt")}
              className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12"
            />
            <a
              href="tel:+41244331124"
              className="hover:underline active:underline italic font-extralight"
            >
              {t("contactform.phone")}
            </a>
          </div>

          <div className="flex gap-7 items-center">
            <img
              src={Images.MAIL}
              alt={t("contactform.emailAlt")}
              className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12"
            />
            <a
              href="mailto:info@aficor.ch"
              className="hover:underline active:underline italic font-extralight"
            >
              {t("contactform.email")}
            </a>
          </div>

          <div className="flex gap-7 items-center">
            <img
              src={Images.MESSAGE}
              alt={t("contactform.smsAlt")}
              className="w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12"
            />
            <a
              href="sms:+41244331124"
              className="hover:underline active:underline italic font-extralight"
            >
              {t("contactform.phone")}
            </a>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="w-full lg:w-2/3 bg-transparent border-2 border-white rounded-xl p-10 order-1 lg:order-2">
        <h3 className="text-2xl font-bold uppercase text-start mb-10">
          {t("contactform.subtitle")}
        </h3>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 lg:grid-cols-2 gap-x-5 gap-y-10"
        >
          <div className="flex flex-col items-start">
            <label htmlFor="name">{t("form.name")}</label>
            <input
              id="name"
              type="text"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col items-start">
            <label htmlFor="entreprise">{t("form.entreprise")}</label>
            <input
              id="entreprise"
              type="text"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.entreprise}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col items-start">
            <label htmlFor="email">{t("form.email")}</label>
            <input
              id="email"
              type="email"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.email}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col items-start">
            <label htmlFor="phonenumber">{t("form.phonenumber")}</label>
            <input
              id="phonenumber"
              type="tel"
              required
              className="w-full rounded-lg bg-transparent border border-white p-2"
              value={formData.phonenumber}
              onChange={handleChange}
            />
          </div>
          <div className="col-span-1 lg:col-span-2 flex flex-col items-start">
            <label htmlFor="message">{t("form.message")}</label>
            <textarea
              id="message"
              required
              className="w-full h-32 rounded-lg bg-transparent border border-white p-2"
              value={formData.message}
              onChange={handleChange}
            />
          </div>

          <div className="col-span-1 lg:col-span-2 flex justify-end">
            <Button
              text={t("form.send")}
              type="submit"
              orientation={"north-east"}
            />
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
